import { render, staticRenderFns } from "./iristarCore.vue?vue&type=template&id=0a10e576&"
import script from "./iristarCore.vue?vue&type=script&lang=js&"
export * from "./iristarCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports